import { html, rune, View } from 'rune-ts';
import klass from './PortfolioSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { PortfolioCard } from './PortfolioCard';
import { map, pipe, toArray } from '@fxts/core';
import { getResizedUrl } from '../../../../../shared/util/image';

export class PortfolioSection extends View {
  readonly TOP_ROW_IMAGE_URLS = [
    '//s3.marpple.co/files/u_4078146/2025/1/original/0e9a02a5fe2ae3683cdd743114567d441954a8611.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/3ae779582eac8cebbd484596f7697766a553abce2.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/fae2f3611718370c3db828a8264c36cebe985a8b3.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/c61c4e20384648ea78302248a199b90dfd59ee194.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/3677dce68e5dfdd267b634d5b95d69bd4d4e59615.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/f28e5fd24c1448efe1d39bc06831a7e4b0c3a35f6.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/0a9feabddbb513e4502d225edb659d7a7bd8056d7.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/40facc95979e283c00b1c0ed26e7d80662c2ff708.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/9499cb629c883e7cf127915e55594cad246228b99.png',
  ];

  readonly BOTTOM_ROW_IMAGE_URLS = [
    '//s3.marpple.co/files/u_4078146/2025/1/original/5640fb9743ff850fcd5ca49dfc3941fa145767fb1.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/2c301228918d7b8bc2b161952e5a260755b9083d2.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/c6b52220b00cfc9f3b543f13cd237ac2e014c0a33.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/7d7fa1f1339c736253897425cd1d812445c8732c4.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/c52a3a34c102c48b1c4df3aa4f099a16890268e25.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/6bbdcdc89e643a86c486d0c85a5c1721b6ad474b6.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/43911df8fc644c0ac93434248338059b5f324fde7.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/b1812c3db53e4b9d2a4b7fb3b252c00a812ce0f98.png',
    '//s3.marpple.co/files/u_4078146/2025/1/original/11b3916bea9b39f14b38cba4a6e52d226b33e3499.png',
  ];

  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    return html`
      <section class="${klass.portfolio}">
        <div class="${klass.title_wrapper}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${html.preventEscape(ET('mps2::landing::popup_store::portfolio_title'))}
          </div>
          <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '14_medium' })}">
            ${html.preventEscape(
              ET(`mps2::landing::popup_store::${is_mobile ? 'mo_' : ''}portfolio_description`),
            )}
          </div>
        </div>

        <div class="${klass.content}">
          <div class="${klass['marquee-wrapper']} ${klass.top}">
            <div class="${klass['marquee-background']}">
              ${this._makePortFolioCards(this.TOP_ROW_IMAGE_URLS)}
            </div>
            <div class="${klass['marquee-background']}" aria-hidden="true">
              ${this._makePortFolioCards(this.TOP_ROW_IMAGE_URLS)}
            </div>
          </div>

          <div class="${klass['marquee-wrapper']} ${klass.bottom}">
            <div class="${klass['marquee-background']}">
              ${this._makePortFolioCards(this.BOTTOM_ROW_IMAGE_URLS)}
            </div>
            <div class="${klass['marquee-background']}" aria-hidden="true">
              ${this._makePortFolioCards(this.BOTTOM_ROW_IMAGE_URLS)}
            </div>
          </div>
        </div>
      </section>
    `;
  }

  private _makePortFolioCards(image_urls: string[]) {
    return pipe(
      image_urls,
      map((imageUrl) =>
        getResizedUrl({
          url: imageUrl,
          width: 1920 * 2,
          format: 'webp',
          quality: 85,
        }),
      ),
      map((imageUrl) => new PortfolioCard({ imageUrl })),
      toArray,
    );
  }
}
